export enum MetricNames {
    TEMPERATURE = 'Temperature',
    HUMIDITY = 'Humidity',
    AIR_QUALITY = 'Air Quality',
    INACTIVITY = 'Inactivity',
    ACTIVITY = 'Activity',
    ILLUMINANCE = 'Illuminance',
    NOISE = 'Noise',
    ENERGY = 'Energy',
    CO2 = 'CO2',
    GAS = 'Gas & Smoke'
}

export enum MetricColors {
    TEMPERATURE = '42, 221, 157',
    HUMIDITY = '47, 191, 222',
    AIR_QUALITY = '94, 92, 230',
    INACTIVITY = '255, 128, 171',
    ACTIVITY = '211, 243, 221',
    ILLUMINANCE = '255, 218, 103',
    NOISE = '139, 195, 74',
    ENERGY = '22, 127, 252',
    CO2 = '167, 152, 255',
    GAS = '94, 92, 230'
}

export interface Metric {
    name: MetricNames,
    color: MetricColors
}

export const Metrics: Metric[] = [
    {
        name: MetricNames.TEMPERATURE,
        color: MetricColors.TEMPERATURE
    },
    {
        name: MetricNames.HUMIDITY,
        color: MetricColors.HUMIDITY
    },
    {
        name: MetricNames.AIR_QUALITY,
        color: MetricColors.AIR_QUALITY
    },
    {
        name: MetricNames.INACTIVITY,
        color: MetricColors.INACTIVITY
    },
    {
        name: MetricNames.ACTIVITY,
        color: MetricColors.ACTIVITY
    },
    {
        name: MetricNames.ILLUMINANCE,
        color: MetricColors.ILLUMINANCE
    },
    {
        name: MetricNames.NOISE,
        color: MetricColors.NOISE
    },
    {
        name: MetricNames.ENERGY,
        color: MetricColors.ENERGY
    },
    {
        name: MetricNames.CO2,
        color: MetricColors.CO2
    },
    {
        name: MetricNames.GAS,
        color: MetricColors.GAS
    }
]